export const EMAIL_COMPOSER_ZOHO_CONSTANTS = {
    LINKS: {
        DRAFTS_URL: 'https://mail.zoho.in/zm/#mail/folder/drafts',
    },
    ACTIONS: {
        OPEN_DRAFTS: 'Open Zoho Drafts',
    },
    API: {
        ERROR_CODE_LINK_REQUIRED: 'ZOHO_LINK_REQUIRED',
        DRAFT_REQUEST_URL_SEGMENTS: ['/integrations/zoho-mail/users/', '/drafts'],
        OAUTH_STATUS_CACHE_BUSTER_PARAM: '_t',
        OAUTH_STATUS_NO_CACHE_HEADERS: {
            CACHE_CONTROL: 'no-cache, no-store, must-revalidate',
            PRAGMA: 'no-cache',
        },
    } as const,
    POST_MESSAGE: {
        TYPE_LINKED: 'ZOHO_LINKED',
        SOURCE: 'ei-notification-zoho-oauth',
        STATUS_LINKED: 'linked',
        STATUS_DENIED: 'denied',
        STATUS_FAILED: 'failed',
    } as const,
    TIMING_MS: {
        WINDOW_CLOSE_DRAIN_DELAY: 400,
        OAUTH_STATUS_PROBES: 3,
        OAUTH_STATUS_PROBE_GAP: 400,
        POLL_INTERVAL: 2000,
        OAUTH_POPUP_CLOSE_POLL_MS: 450,
        POLL_MAX_TICKS: 90,
        DRAFT_POST_OAUTH_MAX_ATTEMPTS: 6,
        DRAFT_POST_OAUTH_DELAY_BASE: 400,
        DRAFT_POST_OAUTH_DELAY_STEP: 200,
    } as const,
    OAUTH_POPUP_NAME: 'zoho-mail-oauth',
    OAUTH_POPUP_FEATURES: 'popup=yes,width=980,height=760,resizable=yes,scrollbars=yes',
    LABELS: {
        CHECKING: 'Preparing…',
        RETRY: 'Retry',
        CONNECT_FIRST: 'Link Zoho Mail',
        SAVE_DRAFT: 'Save as Zoho draft',
        WAITING_OAUTH: 'Completing link…',
    },
    OVERLAY: {
        CHECK_PRIMARY: 'Connecting to Zoho Mail',
        CHECK_SUB: 'Verifying your mailbox',
        SAVE_PRIMARY: 'Saving your draft',
        SAVE_SUB: 'Sending to your Zoho Mail Drafts folder',
        OAUTH_PRIMARY: 'Waiting for Zoho sign-in',
        OAUTH_SUB:
            'Finish Zoho sign-in in the window that opened. Return here when done—this page continues automatically. Close that window yourself if it stays open.',
    },
    MESSAGES: {
        DRAFT_SAVED: 'Draft saved in Zoho Mail.',
        CONGRATULATIONS_COMPANION_TOAST:
            'Draft saved in Zoho Mail under Drafts. Open Zoho Mail to review and send to the client.',
        CONGRATULATIONS_MODAL_ZOHO_DRAFT_DETAIL:
            'The message is in your Zoho Mail Drafts folder - not sent from Navigator. Open Zoho Mail, review the draft, and send it to the client from there when you are ready.',
        CONGRATULATIONS_MODAL_ZOHO_DRAFT_PRIMARY_PLACEHOLDER_TOKEN: '{documentLabel}',
        CONGRATULATIONS_MODAL_ZOHO_DRAFT_PRIMARY_TEMPLATE:
            'The deal has moved forward and your {documentLabel} message is saved as a draft in Zoho Mail.',
        OAUTH_WINDOW_OPENED:
            'A Zoho sign-in window opened. Finish there to link Zoho Mail; this page will continue automatically. Close that window yourself when you are finished.',
        OAUTH_CANCELLED:
            'Zoho access window was closed or rejected. Zoho Mail is still not linked.',
        OAUTH_CLOSED_WITHOUT_FINISH:
            'Zoho wasn’t connected - the window was closed or sign-in didn’t finish.',
        OAUTH_SIGN_IN_DENIED: 'Zoho sign-in was cancelled.',
        OAUTH_CONNECT_FAILED: 'Zoho could not be connected. Please try again.',
        OAUTH_POPUP_BLOCKED:
            'Zoho window could not open. Please allow pop-ups for this site and try again.',
        OAUTH_POLL_TIMEOUT:
            'Zoho link is taking too long. Finish access in the other tab, then click the Zoho button again.',
        LINK_STILL_REQUIRED:
            'Zoho Mail is still not linked. Try completing access in the other tab again.',
        FAILED_DRAFT: 'Could not save the Zoho Mail draft.',
        FAILED_STAGE_AFTER_DRAFT:
            'Draft was saved in Zoho Mail, but the deal stage could not be updated. Refresh the page and try updating the stage from the deal if needed.',
        FAILED_STATUS: 'Could not load Zoho Mail connection status.',
    },
    ARIA: {
        ZOHO_ACTION: 'Zoho Mail connection or save draft',
    },
} as const
